import { Globe, ShieldCheck, Clock, DoorOpen } from "lucide-react";

export const TrustBar = ({ t }) => {
  const items = [
    { icon: Globe, text: t.trust.a },
    { icon: ShieldCheck, text: t.trust.b },
    { icon: Clock, text: t.trust.c },
    { icon: DoorOpen, text: t.trust.d },
  ];
  return (
    <section
      className="relative bg-bendito-surface border-y border-bendito-border"
      data-testid="trust-bar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-6 md:py-7">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="flex items-start gap-3" data-testid={`trust-item-${i}`}>
                <Icon className="w-5 h-5 text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-xs md:text-sm text-bendito-ink/90 leading-snug">
                  {it.text}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
